import React from 'react';
import loadable from '@loadable/component';
import { Switch } from 'react-router-dom';
import { SanitizeUrl, useFeatureFlag } from '@moda/portal-stanchions';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { Loading } from '../components/Loading';
import { PageLayout } from '../components/Layouts';
import { NotFoundRoute } from './NotFoundRoute';
import { LEGACY_ROUTES, LEGACY_CATEGORY_ROUTE } from './LegacyRoutes';
import { PAGE_ROUTES } from './PageRoutes';
import { DEBUG_ROUTES } from './DebugRoutes';

const ErrorPage = loadable(() => import('../pages/ErrorPage'), {
  fallback: <Loading />
});

export const Router = () => {
  // TODO: clean this up after a month or so (this was added in December 2021)
  const enableLegacyRoutes = useFeatureFlag('legacy-routes', [
    { default: true },
    { if: false, then: false }
  ]);

  return (
    <ErrorBoundary FallbackComponent={ErrorPage}>
      <PageLayout>
        <SanitizeUrl>
          <Switch>
            {DEBUG_ROUTES}
            {enableLegacyRoutes && LEGACY_CATEGORY_ROUTE}
            {PAGE_ROUTES}
            {enableLegacyRoutes && LEGACY_ROUTES}
            <NotFoundRoute />
          </Switch>
        </SanitizeUrl>
      </PageLayout>
    </ErrorBoundary>
  );
};
